import { Component, Input } from "@angular/core";
import { ConfigService } from "../../../core/services/config.service";

@Component({
  selector: "app-trb-unlock-indicator",
  templateUrl: "./trb-unlock-indicator.component.html",
  styleUrls: ["./trb-unlock-indicator.component.scss"],
})
export class TrbUnlockIndicatorComponent {
  @Input() visible = true;

  constructor(private configService: ConfigService) {}

  get iconPath(): string {
    const config = this.configService.config;
    const brand = (config?.brand || "").toLowerCase();
    const useCantobyte =
      brand === "cantobyte" || brand === "canto" || !!config?.newDesign;
    return useCantobyte
      ? "assets/skin/cantobyte/trb-unlock-indicator.svg"
      : "assets/skin/trb-unlock-indicator.svg";
  }
}
